export default "https://cdn-static.gokick.com/assets/38a17193d7f2ad0638d84ec7199a8f76eb0c19ef/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";